import { ForwardedRef, forwardRef } from "react";
import { CardI } from "../../../interfaces/CardInterface";
import { StartCardContainer } from "./StartTradingCardStyles";
import { motion } from "framer-motion";

export const StartTraidingCard = forwardRef(
  ({ title, img, text, imgDisplay }: CardI, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <StartCardContainer ref={ref}>
        <div className="flex__center big__text">{title}</div>
        <img src={img} alt="TraidingCard"
        style={{
          display:`${imgDisplay}`
        }}
        />
        <p className="big__text">{text}</p>
      </StartCardContainer>
    );
  }
);

export const MStartTraidingCard = motion.create(StartTraidingCard);
